import { UIComponentViewImpl } from '../../uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../uicomponent';
import { DropDownRowComponentProps, DropDownRowComponentState, DropDownRowComponentHandler } from './dropdownrowcomponent';
import * as React from 'react';
import { DropDownRowCSSStyle } from './dropdownrowcss';
import './dropdown.css';
import { BaseContext } from '../../../../utils/basecontext';

export class DropDownRowViewImpl extends UIComponentViewImpl<UIDataModel>
{
    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
    }
  
    bindHandlers()
    {
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseExit = this.onMouseExit.bind(this);
        this.onRowSelect = this.onRowSelect.bind(this);
    }
     draw(props: DropDownRowComponentProps, state: DropDownRowComponentState, cssStyle: DropDownRowCSSStyle): JSX.Element | boolean
     {
         return(
            <>
                    <div id="dropdown-web-wrapper">
                     {
                         this.getWebView(props, state, cssStyle)
                     }
                 </div>
                 <div id="dropdown-mobile-wrapper">
                     {
                         this.getMobileView(props, state, cssStyle)
                     }
                 </div>
            </>
         );
     }

     getWebView(props: DropDownRowComponentProps, state: DropDownRowComponentState, cssStyle: DropDownRowCSSStyle):JSX.Element
     {
         return(
                <>
                <tr onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseExit} style={props.cssStyle.getInnerWrapperCSSStyle(state.isEnabled, props.isLastIndex)} onClick={this.onRowSelect}>

                        {props.isImageRequired && <td style={props.cssStyle.getIconDivCSSStyle()}>   
                            <img width='14px' height='14px' src={state.isEnabled ? this.getContext().getResources().getImage(props.dropDownDto.getIconName() + "_white.svg") : this.getContext().getResources().getImage(props.dropDownDto.getIconName() + ".svg")}/>
                        </td>}
                        <td style={props.cssStyle.getIconNameLabelCSSStyle(state.isEnabled)}>
                            <label style={{ cursor:'pointer', margin:'0px 7px 0px 7px'}}>
                                {props.dropDownDto.getTitle()}
                            </label>
                        </td>

                </tr>
                </>
         );
     }
     getMobileView(props: DropDownRowComponentProps, state: DropDownRowComponentState, cssStyle: DropDownRowCSSStyle):JSX.Element
     {
         return(
                <>
                <tr onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseExit} style={props.cssStyle.getInnerWrapperCSSStyle(state.isEnabled, props.isLastIndex)} onClick={this.onRowSelect}>

                    {props.isImageRequired && <td style={props.cssStyle.getMobileIconDivCSSStyle()}>   
                        <img width='14px' height='14px' src={state.isEnabled ? this.getContext().getResources().getImage(props.dropDownDto.getIconName() + "_white.svg") : this.getContext().getResources().getImage(props.dropDownDto.getIconName() + ".svg")}/>
                    </td>}
                    <td style={props.cssStyle.getIconNameLabelCSSStyle(state.isEnabled)}>
                        <label style={{ cursor:'pointer', margin:'0px 7px 0px 7px'}}>
                            {props.dropDownDto.getTitle()}
                        </label>
                    </td>

                </tr>
                </>
         );
     }
     onMouseEnter()
     {
        (this.getUIComponentHandler() as DropDownRowComponentHandler).onMouseEnter();
     }

     onMouseExit()
     {
        (this.getUIComponentHandler() as DropDownRowComponentHandler).onMouseExit();
     }

     onRowSelect():void
     {
         (this.getUIComponentHandler() as DropDownRowComponentHandler).onRowSelected();
     }
     
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownrow/dropdownrowview.tsx